// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1Ql8b","icon":"styles_icon__2fTTG"};